import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverviewDateDisplayComponent } from './overview-date-display.component';
import { SourceOfDeadlineBadgeModule } from '../../components/source-of-deadline-badge/source-of-deadline-badge.module';

@NgModule({
  imports: [
    CommonModule,
    SourceOfDeadlineBadgeModule,
  ],
  declarations: [OverviewDateDisplayComponent],
  exports: [OverviewDateDisplayComponent]
})
export class OverviewDateDisplayModule { }
